import { Component, Vue, Watch } from 'vue-property-decorator'
import CategoryPage from '~/components/page/category/CategoryPage'
import LandingPage from '~/components/page/landingPage/LandingPage'
import ProductPage from '~/components/page/product/ProductPage'
import ReviewsPage from '~/components/page/reviews/ReviewsPage'
import UnknownPageType from '~/types/enum/UnknownPageType'
import s from '~/utils/s'

@Component({
  async fetch ({ route, store }) {
    s(store).general.enableLoader()
    const options = {
      route,
      isRedirect: false
    }

    await s(store).unknownPage.checkPage(options)

    const { pageType } = s(store).unknownPage

    if ([UnknownPageType.Reviews].includes(pageType)) {
      await s(store).reviewsPage.fetchReviews(route)
    }

    if ([UnknownPageType.Product, UnknownPageType.Reviews].includes(pageType)) {
      await s(store).reviewsPage.fetchUserReview(route)
    }
    s(store).general.disableLoader()
  },
  transition: 'off'
})
export default class extends Vue {
  isLoad = true

  created () {
    this.isLoad = true
  }

  @Watch('$route.query')
  async watchQuery () {
    switch (s(this.$store).unknownPage.pageType) {
      case UnknownPageType.Category:
        s(this.$store).categoryPage.enableLoader()
        await s(this.$store).categoryPage.loadProducts()
        break
      case UnknownPageType.Product:
        // TODO: load product
        break
      case UnknownPageType.Reviews:
        await s(this.$store).reviewsPage.fetchReviews()
        break
      case UnknownPageType.LandingPage:
        await s(this.$store).landingPage.loadLandingPage()
        break
    }
  }

  renderPage () {
    switch (s(this.$store).unknownPage.pageType) {
      case UnknownPageType.Category:
        return (<CategoryPage key="category" />)
      case UnknownPageType.Product:
        return (<ProductPage key="product" />)
      case UnknownPageType.Reviews:
        return (<ReviewsPage key="reviews" />)
      case UnknownPageType.LandingPage:
        return (<LandingPage key="landingPage" />)
    }
  }

  render () {
    if (this.isLoad) {
      return (
        this.renderPage()
      )
    }
  }
}
